import React from 'react';

import { Row, Col } from "react-bootstrap";
import { AnimatePresence,motion } from 'framer-motion';
import BackgroundVideo from 'next-video/background-video';
import Video from 'next-video';

import '../lib/bootstrap.min.css'
import './Main.css';
import './Welcome.css';

const Welcome = (props) => {    
    console.log(props.db.profile_device[0].content.welcome_page.url_file)
  return (
    <div  id="welcome">
        <AnimatePresence>
            <Row>
                <Col md={12}>
                    <motion.div 
                        className='content-welcome'
                        initial={{ opacity: 0, marginTop: 0 }}
                        animate={{ opacity: 1, marginTop: 0,  }}
                        exit={{opacity:0, marginTop: -300}}
                        transition={{ duration: 0.8, ease: [0.7, 0, 0.3, 1] }}
                    >
                        <Video src={props.db.profile_device[0].content.welcome_page.url_file} autoPlay />;
                        
                    </motion.div>
                </Col>
            </Row>
        </AnimatePresence>
        <button id='skip' tabIndex={0} className='continue' onClick={()=>{props.goToHome()}}>
            Continue
        </button>
    </div>
  )};

export default Welcome;


